<template>
  <utd-toast ref="toastRef"
             position="top-right"
             notification-mode="success"
             :title="title"
             :message="message"
             @closed="handleClosed" />
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import PubSub from '_acaSrc/utility/PubSub';
import UtdToast from '_acaSrc/components/shared/stdlib/UtdToast.vue';

const pubsub = new PubSub();
const toastRef = ref(null);
const title = ref('');
const message = ref('');

const showToast = (data) => {
    if (data) {
        title.value = data.title || '';
        message.value = data.message || '';
        toastRef.value?.show();
    }
};

const handleClosed = () => {
    title.value = '';
    message.value = '';
};

onMounted(() => {
    pubsub.subscribe('showRemoteAccessExtendedToast', showToast);
});

onUnmounted(() => {
    pubsub.unsubscribe('showRemoteAccessExtendedToast');
});
</script>
